module.exports = __webpack_public_path__ + "static/media/search-light.8420619e.svg";